module.exports = __webpack_public_path__ + "img/btn-bg.7905dfa4.png";